module.exports = __webpack_public_path__ + "cd59ddbcd7b00d7c37ca18d85bd4b691.svg";